<template>
    <div class="about">
        <v-container grid-list-md text-xs-center>

            <v-layout row align-center justify-center>
                <h1>Formulir Tiket Reguler</h1>
                <br>
            </v-layout>

            <form @submit.prevent="submit">
                <v-layout row wrap>
                    <v-flex xs12 sm12 md4 lg4 xl4>
                        <v-menu
                                :v-model="menu_tanggal"
                                :close-on-content-click="false"
                                full-width
                                max-width="290"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        :value="format_date(form.tgl_kunjungan)"
                                        clearable
                                        label="Tanggal Kunjungan"
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                    v-model="form.tgl_kunjungan"
                                    @change="menu_tanggal = false"
                                    locale="id-id"
                            ></v-date-picker>
                        </v-menu>
                    </v-flex>
                </v-layout>
                <v-layout row wrap v-for="(item, index) in jumlah_tiket" :key="index">
                    <v-flex xs12 sm12 md4 lg4 xl4>
                        <v-select
                                :items="itemHargaTiket"
                                v-model="form.jenis_tiket[index]"
                                item-text="nama"
                                item-value="id"
                                label="Jenis Tiket"
                        ></v-select>
                    </v-flex>

                    <v-flex xs12 sm12 md4 lg4 xl4>
                        <v-text-field
                                :label="`Nama Lengkap Pengunjung #`+item"
                                v-model="form.nama_anak[index]"
                                required
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md4 lg4 xl4>
                        <v-menu
                                :v-model="menu_tanggal"
                                :close-on-content-click="false"
                                full-width
                                max-width="290"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        :value="format_date(form.tgl_lahir[index])"
                                        clearable
                                        :label="`Tanggal Lahir Pengunjung #`+item"
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                    v-model="form.tgl_lahir[index]"
                                    @change="menu_tanggal = false"
                                    locale="id-id"
                            ></v-date-picker>
                        </v-menu>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <v-btn @click="jumlah_tiket_change">Tambah Form Tiket</v-btn>
                        <v-btn @click="submit" color="primary">Beli</v-btn>
                    </v-flex>
                </v-layout>
            </form>

        </v-container>
    </div>
</template>

<style scoped>
    .rounded-card{
        border-radius:10px;
    }
</style>

<script>
    import HomeAPI from "@/api/home";
    import moment from "moment";
    import store from "@/store/index";
    import swal from "sweetalert2";

    export default {
        data() {
            let tanggal = new Date();
            tanggal.setDate(tanggal.getDate() + 3);
            return {
                menu_tanggal: false,
                form: {
                    tgl_kunjungan: tanggal.toISOString().substr(0, 10),
                    nama_anak: [],
                    tgl_lahir: [],
                    jenis_tiket: [],
                },
                jumlah_tiket: 1,

                itemHargaTiket: [],
                itemPaketGroup: [],
            }
        },
        name: 'about',
        mounted: function(){
            HomeAPI.getHargaTiket().then(response => {
                this.itemHargaTiket = response.data.results.data;
            });
        },
        methods:{
            jumlah_tiket_change(){
                this.jumlah_tiket++;
            },
            submit(){
                store.dispatch("loading/start");
                HomeAPI.postBeliPaketReguler(this.form).then(response => {
                    store.dispatch("loading/stop");
                    if(response.data.success === false) {
                        swal.fire({
                            type: 'error',
                            title: "Pembayaran Bermasalah!",
                            text: "Ada masalah saat menghubungi layanan penyedia pembayaran, silahkan coba lagi.",
                            reverseButtons: false,
                            confirmButtonText: 'ok',
                        });
                    } else {
                        window.location.replace(response.data);
                    }
                }).catch(error => {
                    store.dispatch("loading/stop");
                    console.log(error);
                });
            },
            format_date(tanggal){
                return tanggal ? moment(tanggal).format('DD-MM-YYYY') : '';
            }
        }
    }
</script>